import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"back-link px-1",attrs:{"text":"","small":"","color":"primary","to":_vm.to,"exact":_vm.exact}},[_c(VIcon,{staticClass:"mr-1",attrs:{"small":"","left":""}},[_vm._v("mdi-chevron-left")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }